import { useForm } from 'react-hook-form'
import { Button, Modal } from 'react-bootstrap'
import ButtonLoading from '../../../components/button/ButtonLoading'
import { useAddApiKeyMutation } from '../../../store/kopiliot-api/api-key'
import { useAppSelector } from '../../../store/store'
import React from 'react'
import ApiKey, { ApiKeyResult } from '../../../shared/models/api-key.model'
import ApiKeyForm from '../form/ApiKeyForm'

interface AddApiKeyModalProps {
  isOpen: boolean
  setIsOpen: (o: boolean) => void
}

const AddApiKeyModal = ({ isOpen, setIsOpen }: AddApiKeyModalProps) => {
  const { currentUser } = useAppSelector((state) => state)
  const handleClose = () => {
    setIsOpen(!isOpen)
  }
  const form =
    useForm<
      Pick<ApiKey, 'id' | 'isActive' | 'projectID' | 'projectName' | 'userID'>
    >()
  const [addApiKey, { isLoading, isSuccess, error }] = useAddApiKeyMutation()
  const [result, setResult] = React.useState<ApiKeyResult | null>(null)
  const onSubmit = async (
    data: Pick<
      ApiKey,
      'id' | 'isActive' | 'projectID' | 'projectName' | 'userID'
    >
  ) => {
    try {
      const res = await addApiKey(data).unwrap()
      setResult(res)
    } catch (e) {
      console.log(e)
    }
  }
  return (
    <Modal
      show={isOpen}
      centered
      onHide={handleClose}
      size={'lg'}
      className={'border'}
    >
      <Modal.Header closeButton className="border-bottom-0">
        <Modal.Title as="h5">Créer un ApiKey</Modal.Title>
      </Modal.Header>
      <Modal.Body className={'p-2'}>
        {!isSuccess ? (
          <ApiKeyForm form={form} disabledFields={[]} onSubmit={onSubmit} />
        ) : (
          <div>
            <h3>Clé créé avec succès</h3>
            <div>
              <div>ID:</div>
              <pre>{result?.apiKey.id?.id}</pre>
              <div>Clé:</div>
              <pre>{result?.key}</pre>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          type={'button'}
          variant={'outline-secondary'}
          onClick={handleClose}
        >
          Annuler
        </Button>
        <ButtonLoading
          isLoading={isLoading}
          disabled={isLoading}
          type={'submit'}
          text={'Valider'}
          variant={'outline-primary'}
          onClick={form.handleSubmit(onSubmit)}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default AddApiKeyModal
